import React from 'react';
import AppBrand from 'modules/partial/Brand';
import AppFooter from 'modules/partial/Footer';
import landingBG from 'assets/images/illustrations/landing-bg.svg';
import { IconChevronLeft } from 'modules/common/icons';
import { useHistory, useRouteMatch } from 'react-router-dom';
import PropTypes from 'prop-types';

function BannerLayout({ children }) {
  const history = useHistory();
  const { path } = useRouteMatch();

  const handlOnClick = (e) => {
    e.preventDefault();
    history.goBack();
  };
  return (
    <div className="flex h-full w-full overflow-hidden">
      <div className="w-full lg:w-3/5 sm:flex h-auto sm:h-full bg-secondary-100 hidden">
        <div className="px-24 my-auto w-full">
          <div className="space-y-8 2xl:space-y-12 my-12 2xl:my-32 text-center">
            <h4 className="text-3xl lg:text-5xl 2xl:text-6xl text-primary-500 font-bold">
              Manila Resident’s ID Portal
            </h4>
            <p className="text-lg lg:text-2xl 2xl:text-3xl text-gray-500 font-semibold">
              Apply now for a Resident’s ID
            </p>
            <div className="flex justify-center">
              <img src={landingBG} alt="Landing Main Background" />
            </div>
          </div>
          <AppFooter />
        </div>
      </div>
      <div className="w-full lg:w-2/5 flex h-auto sm:h-full overflow-y-auto">
        <div className="px-8 sm:px-14 my-0 sm:my-auto w-full">
          {path !== '/change-password' && (
            <button
              type="button"
              onClick={handlOnClick}
              className="btn sm light gap-2 text-primary-500 text-base font-medium sm:-ml-8 w-24 mt-5 sm:mt-14 ml-0"
            >
              <span className="p-1 rounded-full bg-secondary-100">
                <IconChevronLeft className="w-5 h-5" />
              </span>
              Back
            </button>
          )}
          <AppBrand className="h-16 w-auto text-center mt-5 sm:mt-12" />
          {children}
        </div>
      </div>
    </div>
  );
}
BannerLayout.defaultProps = {};

BannerLayout.propTypes = {
  children: PropTypes.element.isRequired,
};

export default BannerLayout;
